"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.translations = void 0;
exports.translations = {
    required: 'Required field',
    sin: 'Please enter a valid social insurance number',
    sinLength: 'Please enter a social insurance number with 9 digits',
    ssnLength: 'Please enter a valid social security number with 9 digits(e.g: 123-45-6789)',
    canadianPostalCode: 'The postal code needs to be in the following format: A1A 1A1 or A1A1A1',
    zipCode: 'The Zip code needs to be in the following format: 12345 or 12345-1234',
    phoneNumber: 'Please enter a valid phone number with 10 digits',
    phoneNumberAreaCode: 'Please enter a valid area code',
    dateFormat: 'Please enter a valid date',
    pastDate: 'Please enter a date earlier than today',
    pastYear: 'Please enter a date in the last year',
    futureDate: 'Please enter a date later than today',
    futureOrCurrentDate: 'Please enter a current or future date',
    pastOrCurrentDate: 'Please enter a current or past date',
    currentDate: 'You must enter the current date',
    yearMonth: 'Please enter a date with the format YYYY-MM',
    decimal: 'Please enter a number (with up to 2 decimals)',
    isTrue: 'Please accept the terms',
    invalidFirstName: 'Invalid first name',
    invalidLastName: 'Invalid last name',
    invalidMiddleName: 'Invalid middle name',
    invalidFullName: 'Invalid full name',
    invalidEmail: 'Invalid email',
    accountNumber: 'Please enter a valid account number with at least 7 digits',
    institutionNumber: 'Please enter a valid institution code with 3 digits',
    branchNumber: 'Please enter a valid transit code with 5 digits',
};
